export default "__VITE_ASSET__Bue9c8g0__"